/**
 * Setup Header, contains welcome text
 *
 * activationData:
 * currentStep
 */
define('setup/header/header',['require','knockout','i18next','api-access'],function (require) {
    var ko = require('knockout');
    var i18n = require('i18next');
    var userApi = require('api-access').user;

    return function () {
        var self = this;

        self.activate = function (activationData) {
            self.welcomeText = ko.observable();
            self.stepDescription = ko.observable();
            self.welcomeClass = ko.observable();
            self.isG2MMSchedulingTest = activationData.isG2MMSchedulingTest;
            self.isFreeTrialUser = activationData.isFreeTrialUser;
            self.welcomeClass(self.isFreeTrialUser ? 'welcome-free-trial' : 'welcome');
            self.stepDescription(i18n.t('setup.common.welcomeMessage'));

            /* only for the free trial user's second step the message has to be specific */
            if (self.isFreeTrialUser && activationData.currentStep === 2) {
                self.welcomeText(i18n.t('setup.common.welcomeMessage'));
                self.welcomeClass('welcome-free-trial-sub-text');
            } else if (!self.isFreeTrialUser && activationData.currentStep === 2) {
                self.welcomeText(i18n.t('setup.common.almostThere'));
                self.stepDescription(i18n.t('setup.common.setUpPhone'));
            } else {
                userApi.me().then(function (me) {
                    self.welcomeText(i18n.t('setup.common.welcome', me.firstName));
                });
            }
        };
    };
});

